<template>
  <div
    class="from-archive"
    v-if="calendarCard"
  >
    <div class="from-archive__title">
      z archiwum lp3 na miejscu pierwszym
    </div>
    <div class="from-archive__container">
      <div class="from-archive__content">
        <p class="from-archive__date">
          {{eventDate}}
        </p>
        <p class="from-archive__name">
          {{calendarCard.artists[0].name}}
        </p>
        <p class="from-archive__song-title">
          {{calendarCard.songTitle}}
        </p>
        <i
          v-if="calendarCard.mp3Path !== '' && calendarCard.mp3Path === actualPlay && isPlaying"
          class="material-icons"
          @click="playMP3(calendarCard.mp3Path)"
        >
          pause_circle_outline
        </i>
        <i
          v-if="calendarCard.mp3Path !== '' && calendarCard.mp3Path === actualPlay && !isPlaying"
          class="material-icons"
          @click="playMP3(calendarCard.mp3Path)"
        >
          play_circle_outline
        </i>
        <i
          v-if="calendarCard.mp3Path !== '' && calendarCard.mp3Path !== actualPlay"
          class="material-icons"
          @click="playMP3(calendarCard.mp3Path)"
        >
          play_circle_outline
        </i>
      </div>
      <div
        class="from-archive__photo"
        :class="{photoContentWithoutPhoto: !calendarCard.artists[0].photo}"
        v-bind:style="{ backgroundImage: 'url(' + calendarCard.artists[0].photo + ')' }"
      >
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin';
export default {
  mixins: [mixin],
  components: {
  },
  data() {
    return {
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
  .from-archive {
    width: 100%;
    height: 13.5rem;
    max-width: 700px;
    background-color: #fefefe;
    margin: 1rem auto 0 auto;
    border-radius: 5px;
    font-family: 'Poppins', sans-serif;
    &__title {
      background-color: #df2860;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fefefe;
      font-size: 1.2rem;
      text-transform: uppercase;
      height: 2.5rem;
      font-weight: 700;
      padding: 0.6rem;
    }
    &__container {
      display: flex;
      height: 10rem;
      justify-content: space-between;
      padding: 1rem;
      box-sizing: border-box;
      i.material-icons {
        color: #df2860;
        font-size: 2.5rem;
        cursor: pointer;
      }
    }
    &__date {
      padding-bottom: 0.5rem;
      margin-bottom: 0.5rem;
      border-bottom: 1px solid #df2860;
      font-size: 1rem;
    }
    &__name {
      font-size: 1rem;
      font-weight: 700;
      margin-bottom: 0.5rem;
      font-style: italic;
    }
    &__song-title {
      font-size: 0.8rem;
      font-weight: 700;
      font-style: italic;
      margin-bottom: 0.5rem;
    }
    &__photo {
      height: 8rem;
      width: 14rem;
      border: 1px solid #df2860;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .photoContentWithoutPhoto {
      background-image: url('/img/zaslepa.jpg') !important;
    }
  }
</style>
